// Copyright © 2021 React Training LLC. All rights reserved.
function invariant(value, message) {
  if (value === false || value === null || typeof value === "undefined") {
    throw new Error(message);
  }
}

export default invariant;
